import React, { Component } from 'react'

class SendPayment extends Component {
    state = {
        isLoading: false,
        amount: 0,
    }

    handleChange = (event) => {
        if (event.target.name == 'amount' && event.target.value > this.props.refundAmount) {
            this.setState({
                [event.target.name]: this.props.refundAmount,
            })
            return
        }

        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    componentDidMount = () => {
    }

    render() {
        return (
            <div style={{ maxWidth: 500, width: 500, paddingRight: 40 }}>
                <div className="header">
                    <b>Payment Form</b>
                </div>
                <div className="body m-t-20">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group row">
                                <label className="col-4 col-form-label">Payment Amount</label>
                                <div className="col-8">
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter amount"
                                        value={this.state.amount}
                                        name="amount"
                                        onChange={this.handleChange}
                                        min={0}
                                    />
                                    <span className="text-danger font-weight-bold">Note: Need to update total booking amount after user payment.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="text-right col-6 offset-6">
                            <button
                                onClick={() => this.props.sendPayment(this.state)}
                                className="btn hor-grd btn-grd-inverse offset-1"
                                disabled={this.state.amount <= 0}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default SendPayment
